// LIST
export const FETCH_EVALUATIONS = "app/EVALUATIONS/FETCH_EVALUATIONS";
export const FETCH_EVALUATIONS_SUCCESS =
  "app/EVALUATIONS/FETCH_EVALUATIONS_SUCCESS";
export const FETCH_EVALUATIONS_FAILURE =
  "app/EVALUATIONS/FETCH_EVALUATIONS_FAILURE";

// GET SINGLE
export const FETCH_EVALUATION = "app/EVALUATIONS/FETCH_EVALUATION";
export const FETCH_EVALUATION_SUCCESS =
  "app/EVALUATIONS/FETCH_EVALUATION_SUCCESS";
export const FETCH_EVALUATION_FAILURE =
  "app/EVALUATIONS/FETCH_EVALUATION_FAILURE";

// SAVE (ADD)
export const SAVE_EVALUATION = "app/EVALUATIONS/SAVE_EVALUATION";
export const SAVE_EVALUATION_SUCCESS =
  "app/EVALUATIONS/SAVE_EVALUATION_SUCCESS";
export const SAVE_EVALUATION_FAILURE =
  "app/EVALUATIONS/SAVE_EVALUATION_FAILURE";

// UPDATE (EDIT)
export const UPDATE_EVALUATION = "app/EVALUATIONS/UPDATE_EVALUATION";
export const UPDATE_EVALUATION_SUCCESS =
  "app/EVALUATIONS/UPDATE_EVALUATION_SUCCESS";
export const UPDATE_EVALUATION_FAILURE =
  "app/EVALUATIONS/UPDATE_EVALUATION_FAILURE";

export const UPDATE_PLAN_EVALUATION = "app/EVALUATIONS/UPDATE_PLAN_EVALUATION";
export const UPDATE_PLAN_EVALUATION_SUCCESS =
  "app/EVALUATIONS/UPDATE_PLAN_EVALUATION_SUCCESS";
export const UPDATE_PLAN_EVALUATION_FAILURE =
  "app/EVALUATIONS/UPDATE_PLAN_EVALUATION_FAILURE";
